// @ts-nocheck
import React from 'react';
import moment from 'moment';
import { DatePicker } from '../../../components/ant/DatePicker';
import CommonForm from '../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { FormField } from '../../../components/Form';
import { StyledInputNumber } from '../../../components/hoc/common/components/elements';
import { OrgUnitSelect } from '../../../components';
import { ApproveYesNoSelect } from '../../../components/selects/AutoGeneratedEnumSelects';
export default props => {
  return <CommonForm {...props}>
      {({
      setFieldValue,
      values
    }) => {
      return <>
            <Grid gutter="16px">
              <GridItem>
                <FormField label="Филиал" fast required name="orgUnitId">
                  {({
                name,
                value
              }) => <OrgUnitSelect value={value} onlyBranches onChange={value => setFieldValue(name, value)} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Стоимость нормо-часа работ хоз. способом без НДС, руб " fast required name="price">
                  {({
                name,
                value
              }) => <StyledInputNumber name={name} value={value} onChange={value => setFieldValue(name, value)} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата начала" name="startDate" required>
                  {({
                name,
                value
              }) => <DatePicker name={name} value={value ? moment(value) : value} format="DD MMMM YYYY" onChange={value => {
                setFieldValue(name, moment.utc(value).startOf('day').toISOString());
              }} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Дата окончания" name="endDate" required>
                  {({
                name,
                value
              }) => <DatePicker name={name} value={value ? moment(value) : value} format="DD MMMM YYYY" disabled={!values.startDate} disabledDate={date => values.startDate ? moment.utc(date).startOf('day').isSameOrBefore(moment.utc(values.startDate)) : false} onChange={value => {
                setFieldValue(name, moment.utc(value).startOf('day').toISOString());
              }} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Статус" fast required name="status">
                  {({
                name,
                value
              }) => <ApproveYesNoSelect name={name} value={value} onChange={value => setFieldValue(name, value)} />}
                </FormField>
              </GridItem>
            </Grid>
          </>;
    }}
    </CommonForm>;
};
